import { breakpoints } from '@/config/breakpoints';
import { Row } from 'antd';
import { styled } from 'styled-components';
import { HomeDescription } from '../../style';

export const Wrapper = styled.div`
  /* padding-top: 52px; */
  display: flex;
  flex-direction: column;
  overflow: hidden;
  padding: 0px 24px;
  max-width: 1176px;
  width: 100%;
  /* padding: 0 40px; */
  gap: 40px;
  p,
  span {
    text-align: center;
  }
  @media screen and (max-width: ${breakpoints.lg}) {
    padding: 0 16px;
  }
`;

export const TxtTitle = styled.span`
  color: #fff;
  font-size: 32px;
  /* margin-top: 40px; */
  margin-bottom: 24px;
  font-family: 'GTWalsheimPro';
  font-weight: 700;
  @media screen and (max-width: ${breakpoints.lg}) {
    /* margin-top: 24px; */
    font-size: 20px;
  }
`;

export const Frames = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr 1fr;
  gap: 24px;
  flex-direction: column;
  @media screen and (max-width: ${breakpoints.md}) {
    grid-template-columns: 1fr;
  }
`;

export const FrameProduct = styled.div`
  display: flex;
  flex-direction: column;
  /* cursor: pointer; */
  overflow: hidden;
  width: 100%;
  gap: 16px;
  //margin: 0 -10px;

  .img-wrapper {
    width: 100%;
    height: 267px;
  }

  .text-wrapper {
    /* margin: 16px 0; */
    display: flex;
    flex-direction: column;
    gap: 4px;
    /* height: 110px; */
  }
`;

export const ImageWrapper = styled.div`
  width: 100%;
  border-radius: 12px;
  /* background: #fff; */
  overflow: hidden;
  height: auto;
`;

export const ImageProduct = styled.img`
  /* display: flex; */
  width: 100%;
  transition: all 0.5s;
  /* height: 221px; */
  &:hover {
    transform: scale(1.25, 1.25);
  }
  @media screen and (max-width: ${breakpoints.lg}) {
    /* height: 150px; */
  }
  @media screen and (max-width: ${breakpoints.md}) {
    /* height: auto; */
  }
`;

export const TitleProduct = styled.p`
  color: #fff;
  font-size: 16px;
  font-weight: 700;
  text-align: start !important;
  margin-bottom: 0px;
  line-height: 150%;
  /* margin-top: 16px; */
  @media screen and (max-width: ${breakpoints.md}) {
    font-size: 16px;
    /* margin-bottom: 4px; */
  }
`;

export const DesProduct = styled.p`
  color: #fff;
  font-size: 14px;
  font-weight: 400;
  color: #d2d2d2;
  text-align: start !important;
  margin-bottom: 0px;
  line-height: 150%;
`;

export const GridWrapper = styled.div`
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 24px;
  @media screen and (max-width: ${breakpoints.md}) {
    grid-template-columns: repeat(1, 1fr);
  }
`;

export const CustomDescription = styled(HomeDescription)`
  max-width: 700px;
  margin: 0 auto;
`;
